"use strict";


Proj.SubmitAjaxForm = function(){

	var _form = {},
        _preprocess = 0;
    

    function __init_form() {
        
        _form.each(function(){
              var _self = $(this),
                  _sbn  = _self.find('button[type="submit"]');
            
            if(_preprocess) {
               
               __form_fields(_self);

            }

            _sbn.on("click", function(e){
	            e.preventDefault();
	            
	            var $data = _self.serializeArray(),
                    $can_submit = 1;

	            _self.find(".error").removeClass("error");

	            $data.push({name: '_do', value: 'submit_form'});

	            
                $.fancybox.showLoading();


                Proj.getJSON($data, function(data){__process_form_answer(data,_self);});
               
                

	        });

	    });

    }

    function __form_fields(form_obj) {
        var $form = form_obj;

        $form.find('.p').each(function(){
            var _this = $(this);
            
            if(_this.find('.label').length) {
                _this.find('.label').hide();
                var _placeholder = _this.find('.label').text();
                _this.find('input, textarea').attr('placeholder',_placeholder);
            }
            

        });

        
    }

    function __process_form_answer(data, form) {
        
        $.fancybox.hideLoading();
    	if(data) {
    		if(data.status === "error") {
                
                var i = 0,
                    l = data.errors.length;
    			for(i = 0; i < l; i++) {
                    form.find('.attr-'+data.errors[i]).addClass("error");
    			}

    		} else if(data.status === "ok") {
    			form.html(data.content);
    		}
    	} else {
    		alert("Произошла ошибка при загрузке данных. Попробуйте перезагрузить страницу.");
    	}

    }

    return {

    	init : function(object, flag) {
    		_form = $(object) || {};
            _preprocess = flag;
            __init_form();
    	}

    }
	

}();